import * as React from 'react'

export interface IMaterialSelectOption {
  name: string
  value: string
}

export interface IMaterialSelectProps {
  value?: string
  placeholder?: string
  options: IMaterialSelectOption[]
  onChange?: (value: string) => void
  disabled?: boolean
  disableMaterialPlaceholder?: boolean
  required?: boolean
}

export interface IMaterialSelectState {
  hasValue: boolean
}

export class MaterialSelect extends React.Component<IMaterialSelectProps, IMaterialSelectState> {
  componentWillMount() {
    this.setState({ hasValue: this.props.placeholder ? false : true })
  }

  optionSelected(e: React.ChangeEvent<HTMLSelectElement>) {
    this.setState({ hasValue: true })

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(e.target.value)
    }
  }

  render() {
    return (
      <div className={`material-input-group material-select-group ${this.state.hasValue ? 'hasValue' : ''} ${this.props.disableMaterialPlaceholder ? 'disableMaterialPlaceholder' : ''}`}>
        {this.props.placeholder ? (<label className="material-input-placeholder">{this.props.placeholder}</label>) : null}

        <select value={this.props.value}
          className="form-control material-input"
          onChange={(e) => this.optionSelected(e)}
          disabled={this.props.disabled}
          required={this.props.required}
          defaultValue="">
          {this.props.options.length === 1 ?
            <option value="" disabled={true}>Select</option>
            : null
          }
          {this.props.options.map((o) => (
            <option key={o.value} value={o.value}>{o.name}</option>)
          )}
        </select>
      </div>
    )
  }
}

export default MaterialSelect



// WEBPACK FOOTER //
// ./src/app/components/material/MaterialSelect/index.tsx